<style scoped lang='less'>
// .bottom {
//     position: absolute;
//     margin: auto;
//     height: auto;
//     position: relative;
//     text-align: center;
//     .title {
//         position: absolute;
//         left: 50%;
//         top: 0;
//         transform: translate(-50%, 0);
//         font-size: 35px;
//         color: white;
//         margin: 30px 0 20px;
//         z-index: 100;
//         font-weight: bold;
//     }
//     .nowinfo {
//         text-align: left;
//         position: absolute;
//         left: 50%;
//         bottom: 60px;
//         transform: translate(-50%, 0);
//         color: white;
//         z-index: 100;
//         font-size: 13px;
//         font-weight: 500;
//     }
//     .mask {
//         position: absolute;
//         left: 0;
//         top: 149px;
//         background-color: black;
//         height: 43px;
//         width: 100%;
//         opacity: 0.7;
//     }
//     .whitemask {
//         position: absolute;
//         left: 0;
//         top: 0px;
//         background-color: #888888;
//         height: 180px;
//         width: 100%;
//         opacity: 0.5;
//     }
// }

.bottom {
    background: #141212;
    height: 300px;
    width: 100%;
    .page {
        width: 1300px;
        // background-color: orange;
        display: flex;
        align-items: center;
        height: 100%;
        color: #474747;
        color: rgba(255, 255, 255) !important;
        padding: 0 70px;
        .left-page {
            width: 600px;
            padding-right: 10px;

            > div {
                display: flex;
                align-items: flex-start;
                text-align: left;
                min-height: 30px;
                img {
                    margin-right: 10px;
                    width: 20px;
                }
            }
            .link {
                display: flex;
                .beian {
                    margin-left: 35px;
                }
            }
            .link:hover {
                cursor: pointer;
            }
            .link .fagui:active {
                color: #fff;
            }
            .link .beian:active {
                color: #fff;
            }
        }
        .auto {
            flex: auto;
        }
        .right-page {
            // background: red;
            display: flex;
            .qrCode {
                margin-right: 20px;
                // margin-left: 10px;
                img {
                    width: 100px;
                    height: 100px;
                }
                > div {
                    margin: 10px;
                    font-size: 12px;
                    text-align: center;
                    color: #fff;
                }
            }
        }
    }
}
</style>
<template>
    <div class="bottom">
        <template v-if='this.en'>
            <div class="page">
                <div class="left-page">
                    <div>
                        <img src="http://static.unicornselected.com/FrfW9RFUm6qlRFzbpzGLxfz3Zhgn">
                        <span>
                            Address: Room 1902A, Tower A, Top Plaza, No.118 Guotong Road, Yangpu District, Shanghai, China, 200433
                        </span>
                    </div>
                    <div>
                        <img src="http://static.unicornselected.com/FuHce23vsjUSlchpe1Kw99-VJ9M6">
                        <span class="tnr"> Email: info@unicornselected.com</span>
                    </div>
                    <div class="link">
                        <span
                            class="fagui"
                            @click="gotoAgreement"
                        >Terms of Services</span>
                    </div>
                    <div></div>
                </div>
                <div class="auto"></div>

                <div class="left-page">
                    <div>
                        <img src="http://static.unicornselected.com/FsiQchwBTbcPzqMZYjEDxxOtwtjI">
                        <span class="tnr">Tel: 0086-021-35072278</span>
                    </div>
                    <div>
                        Copyright © All rights reserved for Shanghai Duyi Information Technology Co., Ltd. 沪ICP备19000829号
                    </div>
                    <div></div>
                    <div></div>
                </div>
                <div class="right-page">
                    <div class="qrCode">
                        <img src="http://static.unicornselected.com/FsMuqnGMtJ6BfdZVAmBcoqR-N3Ls">
                        <div>{{'关注小程序'|language}}</div>
                    </div>
                    <div class="qrCode">
                        <img src="http://static.unicornselected.com/FsO1Sn1mB2oFmuILf35g3NBBwzEU">
                        <div>{{'关注公众号'|language}}</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="page">
                <div class="left-page">
                    <div>
                        <img src="http://static.unicornselected.com/FrfW9RFUm6qlRFzbpzGLxfz3Zhgn">
                        上海市杨浦区国通路
                        <span class="tnr">118</span>号天盛广场<span>A</span> 座
                        <span class="tnr">1902A</span>室
                    </div>
                    <div>
                        <img src="http://static.unicornselected.com/FuHce23vsjUSlchpe1Kw99-VJ9M6">
                        联系我们：
                        <span class="tnr">info@unicornselected.com</span>
                    </div>
                    <div class="link">
                        <span
                            class="fagui"
                            @click="gotoAgreement"
                        >平台协议</span>
                        <span class="beian">备案信息：沪ICP备19000829号</span>
                    </div>
                    <!-- <div>ICP备案信息（以及公安备案）</div> -->
                    <div></div>
                </div>
                <div class="auto"></div>

                <div class="left-page">
                    <div>
                        <img src="http://static.unicornselected.com/FsiQchwBTbcPzqMZYjEDxxOtwtjI">
                        <span class="tnr">0086-021-35072278</span>
                    </div>
                    <div>
                        <span class="tnr">Copyright</span> © 上海独易信息科技有限公司.
                        <span class="tnr">All rights reserved.</span>
                    </div>
                    <div></div>
                    <div></div>
                </div>
                <div class="right-page">
                    <div class="qrCode">
                        <img src="http://static.unicornselected.com/FsMuqnGMtJ6BfdZVAmBcoqR-N3Ls">
                        <div>{{'关注小程序'|language}}</div>
                    </div>
                    <div class="qrCode">
                        <img src="http://static.unicornselected.com/FsO1Sn1mB2oFmuILf35g3NBBwzEU">
                        <div>{{'关注公众号'|language}}</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: [],
    components: {},
    data() {
        return {};
    },
    created() {},
    watch: {},
    computed: {},
    methods: {
        gotoAgreement() {
            this.$router.replace('/main/agreement');
        },
    },
};
</script>
<style scoped lang='less'>
</style>